//@ts-check
import React from 'react';
import { Avatar } from '@material-ui/core';
import { withStyles, createStyles } from '@material-ui/core/styles';

var styles = function styles() {
  return createStyles({
    letterAvatar: {}
  });
};
/**
 * @param {import('./types').LetterAvatar & import('@material-ui/core').WithStyles<typeof styles, true>} props
 */


var LetterAvatar = function LetterAvatar(_ref) {
  var text = _ref.text,
      classes = _ref.classes;
  var firstLetters = text.split(' ').map(function (n) {
    return n.length > 0 && n[0].toUpperCase();
  }).join('').substring(0, 2);
  if (firstLetters.length < 2 && text.length > 1) firstLetters += text[1].toLowerCase();
  return React.createElement(Avatar, {
    style: {
      color: '#FFFFFF',
      backgroundColor: '#FF9933'
    },
    className: classes && classes.letterAvatar
  }, firstLetters);
};

var LetterAvatarFormatter = withStyles(styles, {
  withTheme: true,
  name: 'ECLetterAvatar'
})(LetterAvatar);
export default LetterAvatarFormatter;